
import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';

@Injectable({
    providedIn: 'root'
})
export class FacturationService {

    constructor(
        private api: RestApiService
    ) { }

    getGain(): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            this.api.getLocalTest("getGain" || '/MI_Galago/WCF_MI_Galago/REST/getGain', query, true).then((res) => {
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    };

    getEncaissement(): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            this.api.getLocalTest("getEncaissement" || '/MI_Galago/WCF_MI_Galago/REST/getEncaissement', query, true).then((res) => {
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    };

    getControle(): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            this.api.getLocalTest("getControle" || '/MI_Galago/WCF_MI_Galago/REST/getControle', query, true).then((res) => {
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    };

    addCommission(query): Promise<any> {
        return new Promise((resolve, reject) => {

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/addCommission', query, true).then((res) => {
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    };

    validerFacturation(query): Promise<any> {
        return new Promise((resolve, reject) => {

            this.api.post('/MI_Galago/WCF_MI_Galago/REST/validerFacturation', query, true).then((res) => {
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    }
}
